module.exports = __webpack_public_path__ + "img/other_banner.3aea940f.png";